export default __webpack_public_path__ + "VCP-Background-B01.e3f592c.png";